// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerPack__container-cea3af {
  text-decoration: none;
  padding-inline-end: 18px;
}

.StickerPack__icon-c8e454 {
  margin-inline-start: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/StickersSettingsPopup/StickersSettingsContent/StickerPack/StickerPack.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  text-decoration: none;\n  padding-inline-end: 18px;\n}\n\n.icon {\n  margin-inline-start: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StickerPack__container-cea3af`,
	"icon": `StickerPack__icon-c8e454`
};
module.exports = ___CSS_LOADER_EXPORT___;
